




























































































































































































































import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { actionsEvent } from '@/setup';
import { fetchCambioServicio } from './fetchCambioServicio';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import modalverdetalleCS from '@/pantallas/Conecta/CambiosServicio/modalverdetalleCS.vue';
import moment from 'moment';
import Confirmation from '@/components/Confirmation.vue';

import { PermisoAccion } from '@/views/base/VariablesPermisos';

import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
} from 'ag-grid-community';

@Component({
  components: {
    MantenedorGridSinCodigo,
    DatePicker,
    modalverdetalleCS,
    'app-confirmacion': Confirmation,
  },
})
export default class CambiosServicio extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.CambiosServicio;

  @Prop({ default: null }) model_tipo_fecha: any;
  @Prop({ default: null }) filtro_inicio: any;
  nombre: any = '';
  dialogConfirmacion: boolean = false;
  filtro_tipo_fecha: any[] = [];
  filtro_equipo: any[] = [];
  filtro_tecnico: any[] = [];
  filtro_cliente: any[] = [];
  filtro_referencias: any[] = [];
  model_filtro_inicio: any = moment().subtract(1, 'month');
  model_filtro_fin: any = moment();
  model_filtro_tecnico: any = null;
  model_filtro_equipo: any = null;
  model_filtro_cliente: any = null;
  model_referencias: any = null;
  cs_seleccionada: any = null;
  accion_modal: any = null;
  ModalState: boolean = false;
  showReporteGenerado: boolean = false;
  texto_reporte: string = 'TEXTO CUERPO MODAL';
  estado: string = 'Vigente';

  gridApi: GridApi = null;
  LISTA_CAMBIO_SERVICIO: any = [];

  accionVerdetalle: PermisoAccion = {
    accionCodigo: 4,
    visible: false,
  };

  accionAnular: PermisoAccion = {
    accionCodigo: 94,
    visible: false,
  };
  accionesTotales: PermisoAccion[] = [this.accionVerdetalle, this.accionAnular];

  constructor() {
    super();
    actionsEvent.onVerDetalle(this.handlerbuttonmodalVerdetalle);
    actionsEvent.onAnular(this.handlerbuttonmodalAnular);
  }
  async confirmCallback(val: boolean) {
    this.dialogConfirmacion = false;
    if (val) {
      this.loadingService.showLoading();
      return fetchCambioServicio(
        { cambiosernumero: this.cs_seleccionada },
        'conectaCambioServicio/anular'
      )
        .then((data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1') {
            this.$snotify.success(
              'El Cambio de Sertec No. ' +
                this.cs_seleccionada +
                ' ha sido anulada exitosamente',
              {
                timeout: 3000,
              }
            );
            this.applyfilters();
            this.loadingService.hideLoading();
          } else {
            this.loadingService.hideLoading();
            this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          }
        })
        .catch((error: any) => {
          return null;
        })
        .finally(() => {
          return null;
        });
    }
  }
  async handlerbuttonmodalAnular(params: ICellRendererParams) {
    if (params.data['Estado'] == 'Anulado') {
      this.$snotify.error('El estado ya se encuentra Anulado.', {
        timeout: 3000,
      });
      return;
    }
    this.cs_seleccionada = params.data['Número'];
    this.nombre = params.data['Número'];
    this.dialogConfirmacion = true;
  }

  handlerbuttonmodal() {
    this.cs_seleccionada = null;
    this.ModalState = true;
    this.accion_modal = 'CREAR';
  }

  handlerbuttonmodalVerdetalle(params: ICellRendererParams) {
    this.ModalState = true;
    this.accion_modal = 'EDITAR';
    this.estado = params.data['Estado'];
    this.cs_seleccionada = params.data['Número'];
  }

  gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Número',
        field: 'Número',
        hide: false,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Fecha de Registro',
        field: 'Fecha de Alta',
        hide: false,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Fecha de SerTec',
        field: 'Fecha de Instalación',
        hide: false,
        resizable: true,
        valueFormatter: function(params) {
          return moment(params.value).format('DD-MM-YYYY');
        },
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Técnico',
        field: 'Técnico',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Coordinador',
        field: 'Coordinador',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Equipo Afectado',
        field: 'Equipo',
        hide: false,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Serie Afectada',
        field: 'Serie',
        hide: false,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Activación',
        field: 'Activación',
        hide: false,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Plataforma',
        field: 'Plataforma',
        hide: false,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Patente',
        field: 'Patente',
        hide: false,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Descripción',
        field: 'Descripción',
        hide: false,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Referencias',
        field: 'Referencias',
        hide: false,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },

      {
        headerName: 'SIM Afectada',
        field: 'SIM',
        resizable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },

      {
        headerName: 'Estado SIM',
        field: 'Estado SIM',
        resizable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Cliente',
        field: 'Cliente',
        resizable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Acción',
        field: 'Acción',
        resizable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Estado',
        field: 'Estado',
        resizable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
    ],
    pagination: true,
    paginationPageSize: 30,
    onGridReady: this.handleGridReady,
  };

  modalOCCallback(event: any) {
    this.cleanfilters();

    this.ModalState = event;
  }

  async handleGridReady(event: GridReadyEvent) {
    this.LISTA_CAMBIO_SERVICIO = await this.get_grid_data_cambio_servicio();
    this.gridApi = event.api;
    this.gridApi.setRowData(this.LISTA_CAMBIO_SERVICIO);
    this.gridApi.setDomLayout('autoHeight');
  }

  async get_grid_data_cambio_servicio(filter_data: any = null) {
    if (filter_data == null) {
      filter_data = { '': '' };
    }
    this.loadingService.showLoading(
      undefined,
      'get_grid_data_conectaCambioServicio'
    );
    return fetchCambioServicio(filter_data, 'conectaCambioServicio')
      .then((data: any) => {
        this.loadingService.hideLoading('get_grid_data_conectaCambioServicio');
        this.get_filters();
        return data.data.data.LISTA;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async get_filters() {
    this.loadingService.showLoading(undefined, 'get_filters');
    return fetchCambioServicio({}, 'conectaCambioServicio/get_filters_as_ms2')
      .then((data: any) => {
        this.loadingService.hideLoading('get_filters');
        this.filtro_tipo_fecha = data.data.filtros.TIPO_FECHA_FILTRO;
        this.filtro_tecnico = data.data.filtros.TECNICOS.LISTA;
        this.filtro_equipo = data.data.filtros.EQUIPO.LISTA;
        this.filtro_cliente = data.data.filtros.CLIENTES.LISTA;
        this.filtro_referencias = data.data.filtros.REFERENCIAS.LISTA;
      })
      .catch((error: any) => {
        this.loadingService.hideLoading('get_filters');
        return null;
      })
      .finally(() => {
        this.loadingService.hideLoading('get_filters');
        return null;
      });
  }

  async applyfilters() {
    let body: { [key: string]: string } = {
      filtro_cliente: this.model_filtro_cliente,
      filtro_equipo: this.model_filtro_equipo,
      filtro_tipo_fecha: this.model_tipo_fecha,
      filtro_inicio: this.model_filtro_inicio,
      filtro_fin: this.model_filtro_fin,
      filtro_tecnico: this.model_filtro_tecnico,
      filtro_referencias: this.model_referencias,
    };

    this.LISTA_CAMBIO_SERVICIO = await this.get_grid_data_cambio_servicio(body);
    this.gridApi.setRowData(this.LISTA_CAMBIO_SERVICIO);
  }

  async cleanfilters() {
    this.model_filtro_cliente = null;
    this.model_filtro_equipo = null;
    this.model_filtro_equipo = null;
    this.model_filtro_inicio = moment().subtract(1, 'month');
    this.model_filtro_fin = moment();
    this.model_filtro_tecnico = null;
    this.model_tipo_fecha = null;
    this.model_referencias = null;
    this.LISTA_CAMBIO_SERVICIO = await this.get_grid_data_cambio_servicio();
    this.gridApi.setRowData(this.LISTA_CAMBIO_SERVICIO);
  }

  getCliente() {
    /*  TODO VERIFICAR */
    let user = localStorage.getItem('user');
    let clienteDefecto = JSON.parse(
      localStorage.getItem('user').replace(/'/g, '"')
    ).clienteDefecto;
    return clienteDefecto;
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;

    return id;
  }

  closeReporte() {
    this.showReporteGenerado = false;
    this.texto_reporte = '';
  }

  async btn_exportar() {
    let body: { [key: string]: string } = {
      filtro_cliente: this.model_filtro_cliente,
      filtro_equipo: this.model_filtro_equipo,
      filtro_tipo_fecha: this.model_tipo_fecha,
      filtro_inicio: this.model_filtro_inicio,
      filtro_fin: this.model_filtro_fin,
      filtro_tecnico: this.model_filtro_tecnico,
      filtro_referencias: this.model_referencias,
    };

    this.loadingService.showLoading(undefined, 'btn_exportar');
    return fetchCambioServicio(
      {
        clienteDefecto: this.getCliente(),
        user_id: this.getUserID(),
        body: body,
      },
      'conectaCambioServicio/exportar'
    )
      .then((data: any) => {
        if (Number(data.data.CODIGO_RESPUESTA) > 1) {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA);
        } else {
          this.texto_reporte = data.data.MENSAJE_RESPUESTA;
          this.showReporteGenerado = true;
        }
        this.loadingService.hideLoading('btn_exportar');
        return data.data;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }
}
